import { KeycloakProfile } from "keycloak-js";
import { useEffect } from "react";
import axios from "http/customAxios";
import { useConfig } from "../../lib/config";
import { useKeycloak } from "../../components/keycloak-provider";

interface FreshdeskProps {
  propertyTicker?: string;
  userProfile?: KeycloakProfile | undefined;
}

interface FreshdeskSSOResponse {
  token: string;
}

async function fetchToken(
  ssoURL: string,
  username: string,
  backofficeToken: string
): Promise<FreshdeskSSOResponse> {
  return (
    await axios.post<FreshdeskSSOResponse>(
      `${ssoURL}/jwt`,
      {
        username: username,
        email: username,
      },
      {
        headers: {
          Authorization: `Bearer ${backofficeToken}`,
        },
      }
    )
  ).data;
}

async function fetchAndSetToken(ssoURL: string, email: string, backofficeToken: string) {
  const freshdeskSSOResponse: FreshdeskSSOResponse = await fetchToken(
    ssoURL,
    email,
    backofficeToken
  );
  window.FreshworksWidget("authenticate", {
    token: freshdeskSSOResponse.token,
    callback: () => fetchAndSetToken(ssoURL, email, backofficeToken),
  });
}

export function Freshdesk(props: FreshdeskProps) {
  const keycloak = useKeycloak();
  const config = useConfig();

  useEffect(() => {
    if (!props.userProfile?.email) {
      return;
    }
    window.FreshworksWidget("identify", "ticketForm", {
      email: props.userProfile.email,
    });

    window.FreshworksWidget("prefill", "ticketForm", {
      custom_fields: {
        cf_url: window?.location?.href,
        cf_property: props.propertyTicker,
      },
    });
    window.FreshworksWidget("hide", "ticketForm", [
      "custom_fields.cf_property",
      "custom_fields.cf_url",
    ]);
    if (!keycloak.token) {
      return;
    }
    fetchAndSetToken(config.freshdeskSSOUrl, props.userProfile.email, keycloak.token).then(
      undefined
    );
  }, [props.propertyTicker, props.userProfile, keycloak, config.freshdeskSSOUrl]);

  return null;
}
